<template>
  <div>
    <v-layout 
      v-if="matches.length > 0" 
      row 
      wrap>
      <v-flex 
        v-for="(match,i) in matches"
        :key="`match_${i}`"
        xs12 
        sm6
        md4
        lg3
        @click.stop="goMatch(match)">
        <v-layout 
          :class="{'matchContainer-online':match.isMatchOnline,'matchContainer-finish':match.isMatchFinish}"
          class="matchContainer"
          row 
          wrap
          pa-2 
          mx-1
          mb-3>
          <v-flex 
            xs12 
            class=" text-xs-center grey--text">
            {{ clubName(match) }}
          </v-flex>
          <v-flex 
            xs12 
            class="caption text-xs-center grey--text" 
            mb-1>
            {{ category(match) }}
            <span v-if="match.day" >
              - {{ $t('entity.match.day.label') }} {{ match.day }}
            </span>
          </v-flex>
          <v-flex 
            class="text-xs-center"
            xs5
            px-2>
            <img 
              :src="localTeamLogo(match)" 
              class="logo" >
            <br>
            <span :class="{'body-2':match.l > match.v,'grey--text':match.l < match.v}">
              {{ localTeam(match) }}
            </span>
          </v-flex>
          <template v-if="match.isMatchOnline || match.isMatchFinish">
            <v-flex xs2 class="text-xs-center">
              <span class="title">
                {{ match.l }}
                <span> - </span>
                {{ match.v }}
              </span>
              <span
                v-for="(set,i) in matchSets(match)"
                :key="i"
                class="grey--text caption">
                <template v-if="set && set.v>0 && set.l>0">
                  <br>{{ set.l }}-{{ set.v }}
                </template>
              </span>
            </v-flex>
          </template>
          <template v-else>
            <v-flex xs2 class="text-xs-center body-2">
              {{ weekDay(match) }}
              <br>
              {{ hour(match) }}
            </v-flex>
          </template>
          <v-flex 
            class="text-xs-center"
            xs5
            px-2>
            <img 
              :src="visitorTeamLogo(match)" 
              class="logo" >
            <br>
            <span :class="{'body-2':match.l < match.v,'grey--text':match.l > match.v}">
              {{ visitorTeam(match) }}
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout v-else>
      No matches yet
    </v-layout>
  </div>
</template>

<script>
import DateHelper from '@/lib/DateHelper'
import BaseMixin from '@/components/Dashboard/Mixin/BaseMixin'
// const debug = require('debug')('OD::MatchesList')

export default {
  name: 'MatchesList',
  components: {},
  mixins: [BaseMixin],
  props: {
    config: {
      type: Object,
      required: true,
    },
    matches: {
      type: Array,
      required: true,
    },
    clubs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    sets() {
      const sets = []
      const numSets = this.config.maxNumSets ? this.config.maxNumSets : this.config.numPeriods || 0
      for (let index = 0; index < numSets; index++) {
        sets.push(index)
      }
      return sets
    },
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    getSearch(match, searchArray, itemField, findField, blankDefault) {
      const club = this.clubs.find(club => club.id === match.clubId)
      const item = club.search[searchArray].find(item => {
        const id = typeof item === 'object' ? item.id : item
        return match[itemField] === id
      })
      return item
        ? typeof item === 'object'
          ? item[findField]
          : blankDefault
            ? ''
            : item
        : blankDefault
          ? ''
          : match[itemField]
    },
    clubName(match) {
      return this.clubs.find(club => club.id === match.clubId).club
    },
    category(match) {
      return this.getSearch(match, 'categories', 'category', 'text', false)
    },
    localTeam(match) {
      return this.getSearch(match, 'teams', 'localTeam', 'text', false)
    },
    localTeamLogo(match) {
      return this.getSearch(match, 'teams', 'localTeam', 'logo', true)
    },
    visitorTeam(match) {
      return this.getSearch(match, 'teams', 'visitorTeam', 'text', false)
    },
    visitorTeamLogo(match) {
      return this.getSearch(match, 'teams', 'visitorTeam', 'logo', true)
    },
    location(match) {
      return this.getSearch(match, 'locations', 'location', 'text', true)
    },
    mapLink(match) {
      return this.getSearch(match, 'locations', 'location', 'mapLink', true)
    },
    matchSets(match) {
      const sets = []
      const numSets = this.config.maxNumSets ? this.config.maxNumSets : this.config.numPeriods || 0
      for (let index = 0; index < numSets; index++) {
        sets.push(match.sets[index])
      }
      return sets
    },
    goClub(match) {
      this.navigateTo({
        name: 'WeekMatches',
        params: { clubId: match.clubId, year: match.year, week: match.week },
      })
    },
    goMatch(match) {
      this.navigateTo({
        name: 'Match',
        params: { clubId: match.clubId, year: match.year, week: match.week, matchId: match.id },
      })
    },
    weekDay(match) {
      const date = new Date(match.date)
      switch (date.getDay()) {
        case 0:
          return this.$t('page.matches.weekDaysSmall.sunday')
        case 1:
          return this.$t('page.matches.weekDaysSmall.monday')
        case 2:
          return this.$t('page.matches.weekDaysSmall.tuesday')
        case 3:
          return this.$t('page.matches.weekDaysSmall.wednesday')
        case 4:
          return this.$t('page.matches.weekDaysSmall.thursday')
        case 5:
          return this.$t('page.matches.weekDaysSmall.friday')
        case 6:
          return this.$t('page.matches.weekDaysSmall.saturday')
        default:
          return '--'
      }
    },
    hour(match) {
      return match.hour
    },
    matchDate(match) {
      return DateHelper.getDateTextString(`${match.date} ${match.hour}`)
    },
    getSetText(type) {
      switch (type) {
        case 'pointBase':
          return this.$t('page.match.set')
        case 'timeBase':
          return this.$t('page.match.period')
        case 'baseballBase':
          return this.$t('page.match.inning')
      }
    },
  },
}
</script>

<style lang="scss">
.logo {
  max-height: 40px;
  max-width: 40px;
}
.minLogo {
  max-height: 20px !important;
}
.matchsContainer {
  align-items: center;
}
.matchContainer {
  border-top: 1px lightgray solid;
  min-height: 100px;
}
.matchContainer-online {
  border-top: 2px green solid;
}
.matchContainer-finish {
  border-top: 2px orange solid;
}
.blink_me {
  animation: blinker 5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.4;
  }
}
</style>
